/* global jQuery, elementorFrontend, pen_widget_vars */
( function( $ ) {
	jQuery( window ).on( 'elementor/frontend/init', () => {

		// elementorFrontend.hooks.addAction( 'frontend/element_ready/nested-accordion.default', bpdNestedAccordionHandler );
		// elementorFrontend.hooks.addFilter( 'frontend/handlers/pen-journeysection/scroll_top_distance', function( scrollTop ) {
		// 	console.log('test');
		// 	console.log(scrollTop);

		// 	return scrollTop - 230;
		// } );

		

		/*--------------------------------------------------------------------------------
		Manage live search functionality
		--------------------------------------------------------------------------------*/

		/**
		* Search setup and defaults
		**/

		let doAction = false,
		ajaxActive = false,
		firstSearch = true,
		emptyFirst = false;

		let form_data = [];
		const search_options = {
			empty_search: false,
			pagination: 'loadmore',
			page: 1,
			page_type: 'standard',
			page_type_id: false,
			per_page: 8,
			post_type: 'resource',
			tax_query: 'AND',
			template: 'card'
		};

		// Fetch current URL and any pre-search parameters
		const url = new URL(window.location);
		const params = new URLSearchParams(url.search);

		// Submit form on page ready for initial results
		$( document ).ready(function() {
			let form = $('#live-search-form');

			emptyFirst = form.data('emptyfirst');

			if( form.length ) {
				params.forEach((value, key) => {
					if( key == 'cancer_type' ) {
						$('#taxonomy-cancer_type').val(value);

					} else {
						// Check for general filters in URL
						let fields = $(this).find('input:radio[name=' + key + ']');
						if( fields.length !== 0 ) {
							let currentField = fields.filter('[value=' + value + ']');
							currentField.prop('checked', true);

							let label = currentField.data('label');
							if( label.length !== 0 ) {
								currentField.parents('.form-dropdown').find('.dropdown-title').text(label);
							}
						}
					}
				});

				// Check for search terms in URL
				let search = params.get('search');
				if ( search ) {
					$('#live-search').val(search);
				}

				// Initial form submit
				form.submit();
				firstSearch = false;
			}
		});


		/**
		* Utility Functions
		**/

		function getNestedValue( obj, ...args ) {
			return args.reduce((obj, level) => obj && obj[level], obj)
		}

		
		/**
		* Handle form submission
		**/

		// Capture search form submissions
		$( document ).on( 'submit', '#live-search-form', function(e) {
			e.preventDefault();
			let $this = $(this);

			// Disable submit button
			if( ! firstSearch ) $this.find('.search-submit').attr('disabled', true);

			// Start search process
			submitLiveSearch($this);
		});

		// Begin live search process
		function submitLiveSearch( $this ) {
			// Setup form options
			if( $this.data('pagination') ) search_options.pagination = $this.data('pagination');
			if( $this.data('perpage') ) search_options.per_page = $this.data('perpage');
			if( $this.data('searchtype') ) search_options.post_type = $this.data('searchtype');
			if( $this.data('tax_query') ) search_options.tax_query = $this.data('tax_query');
			if( $this.data('template') ) search_options.template = $this.data('template');
			if( $this.data('page_type') ) search_options.page_type = $this.data('page_type');
			if( $this.data('page_type_id') ) search_options.page_type_id = $this.data('page_type_id');
			
			form_data = $this.serializeArray();

			// Reset timeout for new search if necessary
			if( doAction ) { clearTimeout( doAction ); }

			// Execute search, prevent stacked searches with timeout		
			if( firstSearch && emptyFirst ) {
				//
			} else {
				doAction = setTimeout( function() {
					_do_live_search();
				}, 250 );
			}
		}


		/**
		* Handle live search functionality
		**/

		// Execute search
		function _do_live_search() {
			// Exit if AJAX is currently running
			if ( ajaxActive ) return false;

			$('.live-search-container').addClass('processing');

			// Run AJAX search
			ajaxActive = true;

			// Run AJAX
			$.when( _ajax_live_search() ).done(function( response ) {
				// Handle post-search cleanup & display
				_do_after_search( response );
			});
		}

		// Process AJAX
		function _ajax_live_search() {
			let data = {
				action: 'ajax_search',
				form_data: form_data,
				nonce: pen_widget_vars.nonce,
				search_options: search_options
			};

			return $.ajax({
				type: 'POST',
				url: pen_widget_vars.ajaxurl,
				data: data,
				success: function(response) {
					console.log(response);
					ajaxActive = false;
				},
				error: function(error) {
					console.log('error');
					ajaxActive = false;
				}
			});
		}

		// Handle results after search
		function _do_after_search( response ) {
			$('.live-search-container').removeClass('processing');

			_build_results( response );
			doAction = false;
		}

		// Display results
		function _build_results( response ) {
			let template = response.template;
			let post_type = response.post_type;
			let numberposts = response.numberposts;

			if ( numberposts > 0 ) {
				let page = getNestedValue(response, 'pagination', 'page');
				let pagination_type = getNestedValue(response, 'pagination', 'type');
				_destroy( page );
				// $('#live-search-count').text('Results: ' + response.numberposts);

				if( pagination_type == 'loadmore' ) {
					// Append results
					let classList = 'view-' + template + ' live-search-results';
					$('#live-search-results').append( response.results ).attr( 'class', classList );

					// Setup load more button
					let more_pagination = getNestedValue(response, 'pagination', 'more');
					if( more_pagination === false ) {
						$('#live-search-loadmore').html('');
					} else {
						$('#live-search-loadmore').html('<a id="loadmore" href="#" data-page="' + (page + 1) + '">See More</a>');
					}
				}
			}
			// No results
			else {
				_destroy();
				$('#live-search-count').text('Results: 0');
				$('#live-search-results').append('<p class="noresults">No results found.</p>');
				$('#live-search-loadmore').html('');
			}
		}

		// Destroy search results and/or button
		function _destroy( page = 1, style = 'standard' ) {
			if( page !== 1 ) {
				$('#loadmore').remove();
			} else {
				$('#live-search-results').empty();
			}
		}


		/**
		* Handle form interactivity
		**/

		// Handle radio changes
		$(document).on('change', '#live-search-form input[type="radio"]', function(e) {
			e.preventDefault();

			let $this = $(this);
			$this.parents('.form-dropdown').removeClass('open').find('.dropdown-title').text($this.data('label'))

			search_options.page = 1;
			$('#live-search-form').submit();
		});
		

		// Handle load more button
		$( document ).on( 'click', '#loadmore', function(e) {
			e.preventDefault();
			let $this = $(this);

			search_options.page = $this.data('page');

			if ( doAction ) { clearTimeout( doAction ); }

			doAction = setTimeout( function() {
				_do_live_search();
			}, 250 );
		});

		// Handle pagination clicks
		$( document ).on( 'click', '.loadmore .loadmore-page', function(e) {
			e.preventDefault();
			let $this = $(this);

			if( $this.hasClass('enabled') ) {
				search_options.page = $this.data('page');
				if ( doAction ) { clearTimeout( doAction ); }
				doAction = setTimeout( function() {
					_do_live_search();
				}, 250 );
			}
		});

	});
})(jQuery);